import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutoCompleteComponent } from './auto-complete.component';
import { UtilsModule } from '@otas/utils/utils.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropdownContainerComponent } from './dropdown-container/dropdown-container.component';
import { DropdownItemDirective } from './directives/dropdown-item.directive';
import { DropdownTitleDirective } from './directives/dropdown-title.directive';

@NgModule({
  imports: [
    CommonModule, UtilsModule, FormsModule, ReactiveFormsModule
  ],
  declarations: [AutoCompleteComponent, DropdownContainerComponent, DropdownItemDirective, DropdownTitleDirective],
  exports: [AutoCompleteComponent]
})
export class AutoCompleteModule { }

export interface IAutoCompleteSettings {
  needSelection?: boolean;
  keyboardPosition?: 'auto' | 'top';
  selectionOnclick?: boolean;
  isSuggestion?: boolean;
  isForceVisible?: boolean;
  isDynamicData?: boolean;
  isGroup?: boolean;
  placeholder?: string;
  isClearAll?: boolean;
  searchBy?: string[];
  disabled?: boolean;
  maxHeight?: number;
  position?: 'top' | 'bottom';
  searchFn?: string;
  isFocusFirstElement?: boolean;
  autoSelectKey?: string;
  dataToFetch?: any;
  keyboard?: 'english' | 'malayalam' | 'manglish';
}